import { defaultAxios, IParams } from './base';

// export interface IPutLoanProcessPreRequest extends IParams {
//     IPreReqParam;
// }

export const putLoanProcessPreRequest = (params: any) => {
  return defaultAxios().put(`/loan/processPreRequest`, params);
};
